import { useEffect } from "react";
import "./PolicyPages.css"

export default function PrivacyPolicy() {
     
    
  return (
    <div className="policy-container">
      <div className="policy-content">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: April 7, 2025</p>

        <section className="policy-section">
          <h2>1. Introduction</h2>
          <p>
            Welcome to our Privacy Policy. This document explains how we collect, use, and protect your personal
            information when you use our website and services.
          </p>
        </section>

        <section className="policy-section">
          <h2>2. Information We Collect</h2>
          <p>We may collect the following types of information:</p>
          <ul>
            <li>
              <strong>Personal Information:</strong> Name, email address, phone number, billing and delivery address.
            </li>
            <li>
              <strong>Order Information:</strong> Products purchased, order history, payment details.
            </li>
            <li>
              <strong>Technical Information:</strong> IP address, browser type, device information, cookies.
            </li>
            <li>
              <strong>Usage Information:</strong> How you interact with our website, pages visited, time spent.
            </li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>3. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Process and fulfill your orders</li>
            <li>Communicate with you about your orders and account</li>
            <li>Improve our products and services</li>
            <li>Send promotional offers and updates (with your consent)</li>
            <li>Prevent fraud and enhance security</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>4. Cookies and Tracking Technologies</h2>
          <p>
            We use cookies and similar technologies to enhance your browsing experience, analyze site traffic, and
            personalize content. You can manage cookie preferences through your browser settings.
          </p>
        </section>

        <section className="policy-section">
          <h2>5. Information Sharing</h2>
          <p>We may share your information with:</p>
          <ul>
            <li>Service providers who help us operate our business</li>
            <li>Payment processors to complete transactions</li>
            <li>Delivery partners to fulfill orders</li>
            <li>Legal authorities when required by law</li>
          </ul>
          <p>We do not sell your personal information to third parties.</p>
        </section>

        <section className="policy-section">
          <h2>6. Data Security</h2>
          <p>
            We implement appropriate security measures to protect your personal information from unauthorized access,
            alteration, disclosure, or destruction.
          </p>
        </section>

        <section className="policy-section">
          <h2>7. Your Rights</h2>
          <p>Depending on your location, you may have the right to:</p>
          <ul>
            <li>Access your personal information</li>
            <li>Correct inaccurate information</li>
            <li>Delete your information</li>
            <li>Object to certain processing activities</li>
            <li>Withdraw consent</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>8. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any significant changes by
            posting the new policy on this page.
          </p>
        </section>

        <section className="policy-section">
          <h2>9. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us at:</p>
          <p>
            Email: privacy@example.com
            <br />
            Phone: (123) 456-7890
          </p>
        </section>
      </div>
    </div>
  )
}

